import Skeleton from '@components/skeleton'
import {
    TableWrapper,
    TableTitleWrapper,
} from '@components/CustomTable/CustomTable.styles'
import Typography from '@/ui/components/typography'
import {
    TableCell,
    TableCellContent,
    TableFilterButton,
    TableHeader,
    TableHeaderCell,
    TableRow,
    TableSearchBar,
    TableSearchRow,
} from './MdrSkeleton.styles'

interface MdrTableSkeletonProps {
    title: string
}

const MdrTableSkeleton = ({ title }: MdrTableSkeletonProps) => {
    return (
        <Skeleton>
            <TableWrapper>
                <TableTitleWrapper>
                    <Typography variant="m-regular">{title}</Typography>
                </TableTitleWrapper>
                <TableSearchRow>
                    <TableSearchBar />
                    <TableFilterButton />
                </TableSearchRow>
                <TableHeader>
                    {[1, 2, 3, 4, 5].map((i) => (
                        <TableHeaderCell key={i} />
                    ))}
                </TableHeader>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                    <TableRow key={i}>
                        {[1, 2, 3, 4, 5].map((j) => (
                            <TableCell key={j}>
                                <TableCellContent />
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableWrapper>
        </Skeleton>
    )
}

export default MdrTableSkeleton
